import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

interface LinkCellParams extends ICellRendererParams {
  /** Whether the cell should render as a clickable link. */
  canClick: boolean;
  /** Click handler invoked with the row data. */
  onClick: (row: any) => void;
}

/** Generic ag-grid cell renderer that displays the cell value as a clickable link (when permitted). */
@Component({
  standalone: true,
  imports: [CommonModule],
  template: `
    <a
      *ngIf="canClick; else plain"
      href="javascript:void(0)"
      (click)="emit()"
      style="text-decoration: underline; color: #2c69c7; cursor: pointer"
    >
      {{ label }}
    </a>
    <ng-template #plain>
      <span style="color: #2c69c7">{{ label }}</span>
    </ng-template>
  `,
})
export class LinkCellComponent implements ICellRendererAngularComp {
  label = '';
  canClick = false;
  private params!: LinkCellParams;

  agInit(params: LinkCellParams): void {
    this.params = params;
    this.label = params.value ?? '-';
    this.canClick = params.canClick;
  }
  refresh(params: LinkCellParams): boolean {
    this.label = params.value ?? '-';
    this.canClick = params.canClick;
    return true;
  }
  emit(): void {
    this.params.onClick?.(this.params.data);
  }
}
